import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import TailwindSpin from "../TailwindSpin";

// Lazy load auth components
const Login = lazy(() => import("../Screens/AuthDeatils/Login"));
const ForgetPassword = lazy(() => import("../Screens/AuthDeatils/ForgotPassword"));
const CreateNewPassword = lazy(() => import("../Screens/AuthDeatils/CreateNewPassword"));
const Otp = lazy(() => import("../Screens/AuthDeatils/OtpScreen"));
const Sidebar = lazy(() => import("../Screens/LandingScreens/Sidebar"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex justify-center items-center h-screen">
    <TailwindSpin size="large" />
  </div>
);
// import WalletDetailsTable from "../SharedComponents/WalletDetailsTable";
// import WalletDetails from "../Screens/LandingScreens/Wallet/WalletDetails.js";
// import Reports from "../Screens/LandingScreens/Reports/index.js";
// import Wallet from "../Screens/LandingScreens/Wallet";
// import ProtectedRoutes from "./ProtectedRoutes";

const MainComponent = () => {
  // const token = window.sessionStorage?.getItem("token");

  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/create-new-password" element={<CreateNewPassword />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/*" element={<Sidebar />} />
        {/* <Route path="/wallet" element={<Wallet />} /> */}
        {/* <Route path="/wallet-table" element={<WalletDetailsTable />} /> */}
        {/* <Route path="/wallet-details" element={<WalletDetails />} /> */}
        {/* <Route path="/reports" element={<Reports />} /> */}
        {/* <Route element={<ProtectedRoutes />}>
         
        </Route> */}
      </Routes>
      {/* {token && window.sessionStorage.getItem("showSidebar") === "true" ? (
        <Sidebar />
      )
      :(<Navigate to={"/"}/>)} */}
    </Suspense>
  );
};

export default MainComponent;
